export const isIndexDbExists = (dbName: string | null) => {
    return new Promise((resolve) => {
        if (dbName && dbName.length > 0) {
            const request = indexedDB.open(dbName);
            request.onsuccess = () => {
                resolve(true);
            };
            request.onupgradeneeded = (e: any) => {
                e.target.transaction.abort();
                resolve(false);
            };
        }
    });
};

export const asyncLocalStorage = {
    getItem: async (key: string) => {
        return await Promise.resolve(localStorage.getItem(key));
    },
};
